import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="text-2xl font-bold bg-gradient-to-r from-purple-600 via-blue-500 to-amber-500 bg-clip-text text-transparent">
              HyBionics
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('lab-setup')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium"
            >
              3D Lab Setup
            </button>
            <button
              onClick={() => scrollToSection('technology')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium"
            >
              Technology
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-purple-600 to-blue-500 hover:from-purple-700 hover:to-blue-600 text-white transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="flex flex-col space-y-4 px-4 py-6">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium text-left"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium text-left"
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('lab-setup')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium text-left"
            >
              3D Lab Setup
            </button>
            <button
              onClick={() => scrollToSection('technology')}
              className="text-gray-700 hover:text-purple-600 transition-colors font-medium text-left"
            >
              Technology
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-purple-600 to-blue-500 hover:from-purple-700 hover:to-blue-600 text-white w-full"
            >
              Get Started
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;